import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
	selector: 'app-case-remove-image-dailog',
	templateUrl: './case-remove-image-dailog.component.html',
	styleUrls: ['./case-remove-image-dailog.component.scss']
})
export class CaseRemoveImageDailogComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<CaseRemoveImageDailogComponent>,
		@Inject(MAT_DIALOG_DATA) public dailogData:any)
	{
		// THIS IS INTENTIONAL
	}

	ngOnInit(): void {
		// THIS IS INTENTIONAL
	}

	// ON CONFIRM CLICK EVENT TO CLOSE THE POPUP AND SET DELETED TRUE.
	onClickRemoveImage = () => {
		this.dialogRef.close({ isDelete: true });
	}
}